import React from 'react';
const IconCreateAccount = () => {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "31.502",
    viewBox: "0 0 32 31.502"
  }, /*#__PURE__*/React.createElement("g", {
    id: "add-user-svgrepo-com",
    transform: "translate(-5 -4.998)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_921",
    cx: "7.5",
    cy: "7.5",
    r: "7.5",
    transform: "translate(13.5 6.498)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7146",
    d: "M35,39.5C35,32.045,28.508,26,20.5,26S6,32.045,6,39.5",
    transform: "translate(0.5 -4.503)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7147",
    d: "M19,39h8.011",
    transform: "translate(-1.5 -7.751)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7148",
    d: "M24,34v7.5",
    transform: "translate(-2.5 -6.501)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "3"
  })));
};
export default IconCreateAccount;